import React, {useCallback, useRef} from 'react';

import AddIcon from '@mui/icons-material/Add';
import {Box, IconButton} from '@mui/material';
import '../styles';

type FileUploaderProps = {
  onFileSelected: (file: File) => void;
  acceptFiles?: string;
};

export const FileUploader: React.FC<FileUploaderProps> = ({
  onFileSelected,
  acceptFiles = 'image/*,application/pdf,image/jpg,image/jpeg,image/png',
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const triggerFileSelect = useCallback(() => {
    inputRef.current?.click();
  }, []);

  const handleFileChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      if (file) {
        onFileSelected(file);
      }
      event.target.value = '';
    },
    [onFileSelected],
  );

  return (
    <Box
      className="minimal-uploader-container"
      onClick={triggerFileSelect}>
      <input
        type="file"
        ref={inputRef}
        accept={acceptFiles}
        hidden
        onChange={handleFileChange}
      />
      <IconButton
        className="minimal-uploader-button"
        aria-label="upload file"
        title="Upload file"
        size="small">
        <AddIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};
